import React, { useState, useEffect } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import './Toolbar.scss';
import { Button, Checkbox, FormControlLabel, Slider, Tooltip, Typography  } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import WeatherTools from './weatherContents/WeatherTools';
import Tabs from '@mui/material/Tabs';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import { StyledTab } from 'src/shared/Styles/Styles';
import TuneIcon from '@mui/icons-material/Tune';
import FeatureFilter from "@arcgis/core/layers/support/FeatureFilter";
import {useElevationFilter, useMapDataType, useElementRadioSelect,useElementSelection , useDates, useMidDateSelected, useCurrentDateSlider, useChartTableSelect, useSeasonalTrend, useNetworkType} from '../../../store/actions';
import { useStoreContext } from '../../../store/context';
import { useHistory, useLocation } from 'react-router';
import { ROUTE_PATHS } from 'src/routes';
import FieldSampleTools from './fieldSampleContents/FieldSampleTools';
import { buildPath, ONEMIN, ONESEC } from 'src/store/common';
import { DataTypeList, networkList, nfdrRadioButtons, seasonalTrendList, weatherRadioButtons } from 'src/constants';
import NfdrTools from './nfdrContents/NfdrTools';
import InfoIcon from '@mui/icons-material/Info';

let today = new Date();
let todaylocal = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), 0, 0);
let past = todaylocal.getTime() - (30*ONEMIN);
let future = todaylocal.getTime() + (30*ONEMIN)-ONESEC;

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}


interface ToolBarProps {
    children?: React.ReactNode;
    view: any,
    map: any
}

const ToolBar = (props: ToolBarProps) => {
    const { children, map } = props
    const [open, setOpen] = useState<boolean>(true);
    const [tabValue, setTabValue] = useState(0);
    const [closeAllTabs, setCloseAllTabs] = useState<boolean>(false);
    const [state, dispatch] = useStoreContext();
    const setElevation = useElevationFilter(dispatch);
    const setMapData = useMapDataType(dispatch);
    const setRadio = useElementRadioSelect(dispatch);
    const setElement = useElementSelection(dispatch);
    const history = useHistory();
    const location = useLocation(); 
    const setDates = useDates(dispatch);
    const setMiddleDate = useMidDateSelected(dispatch);
    const setCurrentSliderDate = useCurrentDateSlider(dispatch);
    const selectChartTableType = useChartTableSelect(dispatch);
    const [minValue, setMinValue] = useState<number|''>(0);
    const [maxValue, setMaxValue] = useState<number|''>(12120);
    
    const setSeasonTrend = useSeasonalTrend(dispatch);
    const setNetwork = useNetworkType(dispatch);

    /*useEffect below will check the path in the url*/
    useEffect(()=>{
        if(location.search){
            const stringArray = decodeURIComponent(location.search).split("/");
            const minElevation = Number(stringArray[5]);
            const maxElevation = Number(stringArray[6]);
            const mapType = stringArray[0].substring(1);
            if(!state.selectedElement){
                if(stringArray.length>=9){
                    const type = stringArray[1];
                    const element = stringArray[2];
                    const base = stringArray[4];
                    const minEle = Number(stringArray[5]);
                    const maxEle = Number(stringArray[6]);
                    let windOrNot:any = stringArray[7];
                    let speedOrNot:any = stringArray[8];
                    if(windOrNot==='true'){
                        windOrNot=true;
                    }
                    if(speedOrNot==='true'){
                        speedOrNot=true
                    }
                    if(windOrNot==='false'){
                        windOrNot=false
                    }
                    if(speedOrNot==='false'){
                        speedOrNot=false
                    }
                    if (state.elevationFilterValues[0] !== minEle || state.elevationFilterValues[1] !== maxEle) {
                        setMinValue(minEle);
                        setMaxValue(maxEle);
                        setElevation([minEle, maxEle])
                    }

                    if(mapType==='Weather' || mapType==='FieldSample' || mapType==='FireDanger'){
                        const min = Number.isNaN(minEle)? 0:minEle;
                        const max = Number.isNaN(maxEle)? 12120: maxEle;
                        const paramsForBuildPath = {
                            dataType: mapType,
                            radio: type,
                            element: element,
                            zoom: state.currentZoom,
                            basemap: base,
                            minElevation: min,
                            maxElevation: max,
                            windOrMethod: windOrNot,
                            windOrSub: speedOrNot
                        }
                        buildPath(paramsForBuildPath, history);
                        setMapData(mapType)

                    }

                }
                if(sessionStorage.getItem('path') ){
                    const storagePath = sessionStorage.getItem('path');
                    const storagePathStr = storagePath?.split('/');
                    if(storagePathStr) {
                        const storageMapType =storagePathStr[0].substring(1);
                        if(storageMapType!=='Weather' && storageMapType!=='FieldSample' && storageMapType!=='FireDanger'){
                            const paramsForBuildPath = {
                                dataType: 'Weather',
                                radio: state.selectedRadio.type,
                                element: state.selectedElement? state.selectedElement.value : weatherRadioButtons[0].elementSelections[0].value,
                                zoom: state.currentZoom,
                                basemap: state.selectedBaseMap.id,
                                minElevation: state.elevationFilterValues[0],
                                maxElevation: state.elevationFilterValues[1],
                                windOrMethod: state.wind_direction,
                                windOrSub: state.wind_speed
                            }
                            buildPath(paramsForBuildPath, history);
                            setMapData('Weather');                    
                        }
                        else{
                            const type = storagePathStr[1];
                            const element = storagePathStr[2];
                            const base = storagePathStr[4];
                            const minEle = Number(storagePathStr[5]);
                            const maxEle = Number(storagePathStr[6]);
                            let windOrNot:any = storagePathStr[7];
                            let speedOrNot:any = storagePathStr[8];
                            if(windOrNot==='true'){
                                windOrNot=true;
                            }
                            if(speedOrNot==='true'){
                                speedOrNot=true
                            }
                            if(windOrNot==='false'){
                                windOrNot=false
                            }
                            if(speedOrNot==='false'){
                                speedOrNot=false
                            }
                            if (state.elevationFilterValues[0] !== minEle || state.elevationFilterValues[1] !== maxEle) {
                                setMinValue(minEle);
                                setMaxValue(maxEle);
                                setElevation([minEle, maxEle])
                            }
    
                            if(storageMapType==='Weather' || storageMapType==='FieldSample' || storageMapType==='FireDanger'){
                                const min = Number.isNaN(minEle)? 0:minEle;
                                const max = Number.isNaN(maxEle)? 12120: maxEle;
                                const paramsForBuildPath = {
                                    dataType: storageMapType,
                                    radio: type,
                                    element: element,
                                    zoom: state.currentZoom,
                                    basemap: base,
                                    minElevation: min,
                                    maxElevation: max,
                                    windOrMethod: windOrNot,
                                    windOrSub: speedOrNot
                                }
                                buildPath(paramsForBuildPath, history);
                            }
                            setMapData(storageMapType)
                        }
                    }
                }
            }

            if(!sessionStorage.getItem('path')){
                if (mapType !== state.mapDataType) {
                    if(mapType!== 'Weather' && mapType!=='FieldSample' && mapType!=='FireDanger'){
                        setMapData('Weather');
                    }
                    else{
                        setMapData(mapType);
                    }
                }
                if (state.elevationFilterValues[0] !== minElevation || state.elevationFilterValues[1] !== maxElevation) {
                    setMinValue(minElevation);
                    setMaxValue(maxElevation);
                    setElevation([minElevation, maxElevation])
                }
                if(state.mapDataType!=='Weather' && state.mapDataType!=='FieldSample' && state.mapDataType!=='FireDanger'){
                    const paramsForBuildPath = {
                        dataType: 'Weather',
                        radio: state.selectedRadio.type,
                        element: state.selectedElement? state.selectedElement.value : weatherRadioButtons[0].elementSelections[0].value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.wind_direction,
                        windOrSub: state.wind_speed
                    }
                    buildPath(paramsForBuildPath, history);
                }
                if(state.mapDataType==='Weather' || state.mapDataType==='FireDanger'){
                    const paramsForBuildPath = {
                        dataType: state.mapDataType,
                        radio: state.selectedRadio.type,
                        element: state.selectedElement? state.selectedElement.value : weatherRadioButtons[0].elementSelections[0].value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.mapDataType==='FireDanger'?  state.nfdrFuelModel: state.wind_direction,
                        windOrSub: state.mapDataType==='FireDanger'? false: state.wind_speed
                    }
                    buildPath(paramsForBuildPath, history);
                }
                if(state.mapDataType==='FieldSample'){
                    const paramsForBuildPath = {
                        dataType: state.mapDataType,
                        radio: state.fsMapCategory,
                        element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.fsMapMethod.code_key,
                        windOrSub: state.fsMapSubCat.code_key
                    }
                    buildPath(paramsForBuildPath, history);
                    
                }
            }

        }
        if(!location.search){
            if(sessionStorage.getItem('path')){
                const path = sessionStorage.getItem('path');
                if(path!==null){
                    history.push({pathname: `${ROUTE_PATHS.home}`, search: path});
                }
            }
            else{
                if(state.mapDataType==='Weather' || state.mapDataType===''){
                    setMapData('Weather')
                    const paramsForBuildPath = {
                        dataType: 'Weather',
                        radio: state.selectedRadio.type,
                        element: state.selectedElement? state.selectedElement.value : weatherRadioButtons[0].elementSelections[0].value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.wind_direction,
                        windOrSub: state.wind_speed
                    }
                    buildPath(paramsForBuildPath, history);
                }
                if(state.mapDataType==='FireDanger'){
                    setMapData('FireDanger')
                    const paramsForBuildPath = {
                        dataType: 'FireDanger',
                        radio: state.selectedRadio.type,
                        element: state.selectedElement? state.selectedElement.value : nfdrRadioButtons[0].elementSelections[6].value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod:  state.nfdrFuelModel,
                        windOrSub: false
                    }
                    buildPath(paramsForBuildPath, history);
                }
                if(state.mapDataType==='FieldSample'){
                    setMapData('FieldSample')
                    const paramsForBuildPath = {
                        dataType: 'FieldSample',
                        radio: state.fsMapCategory,
                        element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.fsMapMethod.code_key,
                        windOrSub: state.fsMapSubCat.code_key
                    }
                    buildPath(paramsForBuildPath, history);
                    
                }
            }
        }
        
    },[state.selectedElement, state.selectedRadio.type, state.selectedBaseMap.id,
        location.search, state.currentZoom, history, state.elevationFilterValues, setElevation,
        state.wind_direction, state.wind_speed, state.mapDataType, setMapData, state.fsMapFuel, state.fsMapCategory,
        state.fsMapMethod, state.fsMapSubCat,  state.nfdrFuelModel
    ]);

    const applyFilter = (minElevation: number, maxElevation: number) => {
        if(state.mapDataType==='Weather'){
            const paramsForBuildPath = {
                dataType: state.mapDataType,
                radio: state.selectedRadio.type,
                element: state.selectedElement.value,
                zoom: state.currentZoom,
                basemap: state.selectedBaseMap.id,
                minElevation: minElevation,
                maxElevation: maxElevation,
                windOrMethod: state.wind_direction,
                windOrSub: state.wind_speed
            }
            buildPath(paramsForBuildPath, history);
        }
        if(state.mapDataType==='FireDanger'){
            const paramsForBuildPath = {
                dataType: state.mapDataType,
                radio: state.selectedRadio.type,
                element: state.selectedElement.value,
                zoom: state.currentZoom,
                basemap: state.selectedBaseMap.id,
                minElevation: minElevation,
                maxElevation: maxElevation,
                windOrMethod: state.nfdrFuelModel,
                windOrSub: false
            }
            buildPath(paramsForBuildPath, history);
        }
        if(state.mapDataType==='FieldSample'){
            const paramsForBuildPath = {
                dataType: state.mapDataType,
                radio: state.fsMapCategory,
                element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                zoom: state.currentZoom,
                basemap: state.selectedBaseMap.id,
                minElevation: minElevation,
                maxElevation: maxElevation,
                windOrMethod: state.fsMapMethod.code_key,
                windOrSub: state.fsMapSubCat.code_key
            }
            buildPath(paramsForBuildPath, history);
        }
        const networkString = state.network.map((network)=>network.where).join(' OR ')

        map.layers.forEach((layer) => {
          if (layer.id.includes('observation') || layer.id.includes('forecastValues') || layer.id.includes('windDirectionArrows') || layer.id.includes('windSpeedBarbs') || layer.id.includes('NFDR')) {
            const filter = new FeatureFilter({
              where: `(elevation >= ${minElevation} AND elevation <= ${maxElevation}) 
              ${ state.seasonalTrend?.length===1 ? `AND ${state.seasonalTrend[0].where}`:''} \
              ${ state.seasonalTrend?.length>1 ? `AND (${state.seasonalTrend[0].where} OR ${state.seasonalTrend[1].where})`:''} 
              ${ state.seasonalTrend?.length<1 ? `AND (has_historic_data!=0 AND has_historic_data!=1)`:''}
                ${state.network.length > 0 && 'AND'} 
                ${state.network.length > 0 && (networkString)}
              `
            });
            layer.definitionExpression = filter.where;
          }
            if (layer.id.includes('fieldSample')) {
                const filter = new FeatureFilter({
                    where: `elevation >= ${minElevation} AND elevation <= ${maxElevation}`
                });
                layer.definitionExpression = filter.where;
            }
        });
      };
    
      const elevationChange = (event: Event, newValue: number | number[]) => {
        if (Array.isArray(newValue)) {
            const [newMin, newMax] = newValue;
            const adjustedValues: [number, number] = [Math.min(newMin, newMax), Math.max(newMin, newMax)];
            setMinValue(Math.min(newMin, newMax));
            setMaxValue(Math.max(newMin, newMax))
            setElevation(adjustedValues);
            applyFilter(adjustedValues[0], adjustedValues[1]);
          }
      };
    
      const handleMinInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newMin = Number(event.target.value);
        setMinValue(event.target.value ===''?'': newMin)
        setElevation([newMin, state.elevationFilterValues[1]]);
        applyFilter(newMin, state.elevationFilterValues[1]);
      };
    
      const handleMaxInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newMax = Number(event.target.value);
        setMaxValue(event.target.value ===''?'': newMax)
        setElevation([state.elevationFilterValues[0], newMax]);
        applyFilter(state.elevationFilterValues[0], newMax);
      };
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabValue(newValue);
    };

    const handleClickTab = (event: any, prevTabValue: number) => {
        if ((prevTabValue === Number(event.target.id[event.target.id?.length - 1]) && !closeAllTabs)) {
            setCloseAllTabs(!closeAllTabs)
        }
        else {
            setCloseAllTabs(false)
        }
    };

    const classNameHide = () => {
        if (!open) {
            return 'hide'
        }
        if (open && closeAllTabs) {
            return 'toolbar-close smooth-scrollbar'
        }
        if (open && !closeAllTabs) {
            return 'toolbar smooth-scrollbar'
        }
    }

    const handleDataTypeSelect =(event:any)=>{
        const mapDataTypeValue = event.target.value
        setMapData(mapDataTypeValue);
        if(mapDataTypeValue ==='Weather'){
            if(state.mapDataType!=='Weather'){
                setRadio(weatherRadioButtons[0]);
                setElement(weatherRadioButtons[0].elementSelections[0]);
                selectChartTableType(weatherRadioButtons[0].elementSelections[0].defaultChart)
                setDates([new Date(past), new Date(future)]);
                setMiddleDate(todaylocal.getTime())
                setCurrentSliderDate(todaylocal.getTime())
                const paramsForBuildPath = {
                    dataType: mapDataTypeValue,
                    radio: weatherRadioButtons[0].type,
                    element: weatherRadioButtons[0].elementSelections[0].value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
            else{
                const paramsForBuildPath = {
                    dataType: mapDataTypeValue,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement? state.selectedElement.value : weatherRadioButtons[0].elementSelections[0].value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.wind_direction,
                    windOrSub: state.wind_speed
                }
                buildPath(paramsForBuildPath, history);
            }
        }
        if(mapDataTypeValue ==='FireDanger'){
            if(state.mapDataType!=='FireDanger'){
                setRadio(nfdrRadioButtons[0]);
                setElement(nfdrRadioButtons[0].elementSelections[6]);
                selectChartTableType(nfdrRadioButtons[0].elementSelections[6].defaultChart)
                setDates([new Date(past), new Date(future)]);
                setMiddleDate(todaylocal.getTime())
                setCurrentSliderDate(todaylocal.getTime())
                const paramsForBuildPath = {
                    dataType: mapDataTypeValue,
                    radio: nfdrRadioButtons[0].type,
                    element: nfdrRadioButtons[0].elementSelections[6].value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
            }
            else{
                const paramsForBuildPath = {
                    dataType: mapDataTypeValue,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement? state.selectedElement.value : nfdrRadioButtons[0].elementSelections[0].value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
            }
        }
        if(mapDataTypeValue ==='FieldSample'){
            const paramsForBuildPath = {
                dataType: mapDataTypeValue,
                radio: state.fsMapCategory,
                element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                zoom: state.currentZoom,
                basemap: state.selectedBaseMap.id,
                minElevation: state.elevationFilterValues[0],
                maxElevation: state.elevationFilterValues[1],
                windOrMethod: state.fsMapMethod.code_key,
                windOrSub: state.fsMapSubCat.code_key
            }
            buildPath(paramsForBuildPath, history);
        }
    }

    const handleSeasonalTrendSelect = (value:any)=>{
        let tempSeasonTrend = state.seasonalTrend;
        const found = tempSeasonTrend.findIndex((trend: any)=>trend.label === value.label)
        if(found===-1){
            tempSeasonTrend.push(value)
            setSeasonTrend(tempSeasonTrend)
        }
        else{
            tempSeasonTrend.splice(found,1)
            setSeasonTrend(tempSeasonTrend)
        }
        const networkString = state.network.map((network)=>network.where).join(' OR ')
        map.layers.forEach((layer:any) => {
            if (layer.id.includes('observation') || layer.id.includes('forecastValues') || layer.id.includes('windDirectionArrows') || layer.id.includes('windSpeedBarbs')|| layer.id.includes('NFDR')) {
              const filter = new FeatureFilter({
                    where: `(elevation >= ${state.elevationFilterValues[0]} AND elevation <= ${state.elevationFilterValues[1]}) 
                        ${ tempSeasonTrend.length===1 ? `AND ${tempSeasonTrend[0].where}`:''} \
                        ${ tempSeasonTrend?.length>1 ? `AND (${tempSeasonTrend[0].where} OR ${tempSeasonTrend[1].where})`:''} 
                        ${ tempSeasonTrend?.length<1 ? `AND (has_historic_data!=0 AND has_historic_data!=1)`:''}
                        ${state.network.length > 0 && 'AND'} 
                        ${state.network.length > 0 && `(${networkString})`}
                    `
                });
                layer.definitionExpression = filter.where;
            }
        });
    }

    const handleNetworkSelect = (value: any) => {
        let tempNetworks = state.network;
        const found = tempNetworks.findIndex((network: any) => network.label === value.label)
        if (found === -1) {
            tempNetworks.push(value)
            setNetwork(tempNetworks)
        }
        else {
            tempNetworks.splice(found, 1)
            setNetwork(tempNetworks)
        }
        const networkString = tempNetworks.map((network)=>network.where).join(' OR ')
        map.layers.forEach((layer: any) => {
            if (layer.id.includes('observation') || layer.id.includes('forecastValues') || layer.id.includes('windDirectionArrows') || layer.id.includes('windSpeedBarbs') ||  layer.id.includes('NFDR')) {
                const filter = new FeatureFilter({
                    where: `elevation >= ${state.elevationFilterValues[0]} AND elevation <= ${state.elevationFilterValues[1]}
                        ${ state.seasonalTrend?.length===1 ? `AND ${state.seasonalTrend[0].where}`:''} 
                        ${ state.seasonalTrend?.length>1 ? `AND (${state.seasonalTrend[0].where} OR ${state.seasonalTrend[1].where})`:''} 
                        ${ state.seasonalTrend?.length<1 ? `AND has_historic_data!='false' AND has_historic_data!='true'`:''}
                        ${tempNetworks.length > 0 && 'AND'} 
                        ${tempNetworks.length > 0 && `(${networkString})`}
                    `
                });
                layer.definitionExpression = filter.where;
            }
        });
    }

    return (
        <div className='toolbarContainer'>
            <Button sx={{ borderRadius: '0px 4px 4px 0px' }} aria-label='open toolbar' onClick={() => setOpen(!open)} variant='contained' className={open ? 'hide' : 'closeArrow'}><KeyboardArrowRightIcon /></Button>

            <div className={classNameHide()}>
                <Button sx={{ borderRadius: '0px 4px 4px 0px' }} aria-label='close toolbar' onClick={() => setOpen(!open)} variant='contained' className='openArrow'>
                    <KeyboardArrowLeftIcon />
                </Button>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs value={tabValue}
                            onChange={handleChange}
                            aria-label="Map Tabs"
                            variant="scrollable"
                            TabIndicatorProps={{ style: { backgroundColor: 'white' } }}
                            scrollButtons={false}
                        >
                            <StyledTab label="Data" value={0} icon={<SearchIcon fontSize='small' />} {...a11yProps(0)} onClick={(e) => { handleClickTab(e, tabValue) }} />
                            <StyledTab label="Filters" value={1} icon={<TuneIcon fontSize='small' />}  {...a11yProps(1)} onClick={(e) => { handleClickTab(e, tabValue) }} />
                        </Tabs>
                    </Box>
                    <div className={closeAllTabs ? 'hide' : ''}>
                        <CustomTabPanel value={tabValue} index={0}>
                            <Accordion className='accordion-style' defaultExpanded>
                                <AccordionSummary
                                    className='accordion-title'
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="DataType"
                                    id="DataType"
                                >
                                    <label id='DataType' htmlFor='DataType'>Data Type</label>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Select
                                        onChange={(event) => handleDataTypeSelect(event)}
                                        value={state.mapDataType}
                                        id="DataType"
                                        style={{ fontSize: 'small', width: '90%', marginTop: '2px', backgroundColor: 'white', color: 'black', height: '2rem'}}
                                        className="select-styles"
                                        inputProps={{
                                            id: 'DataType',
                                        }}
                                    >
                                        {
                                            DataTypeList.map((dt: any) => (
                                                <MenuItem value={dt.value} key={`${dt.value}-data-type`}>
                                                    {dt.label}
                                                </MenuItem>
                                            ))
                                        }

                                    </Select>
                                </AccordionDetails>
                            </Accordion>
                            {state.mapDataType==='Weather' && <WeatherTools />}
                            {state.mapDataType==='FieldSample' && <FieldSampleTools/>}
                            {state.mapDataType==='FireDanger' && <NfdrTools/>}

                            {children}
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={1}>
                            <Accordion className='accordion-style' defaultExpanded>
                                <AccordionSummary
                                    className='accordion-title'
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="stationElevation"
                                    id="stationElevation"
                                >
                                      <div>Station Elevation</div>
                                </AccordionSummary>
                                <AccordionDetails>
                                <div>
                                <Slider
                                    value={state.elevationFilterValues}
                                    onChange={elevationChange}
                                    min={0}
                                    max={15000}
                                    id="stationElevation"
                                    aria-labelledby="stationElevation"
                                />
                                <Typography variant="body2" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <input
                                    type="number"
                                    value={minValue}
                                    onChange={handleMinInputChange}
                                    aria-label="Min Elevation" // Accessibility label
                                    style={{ textAlign: 'left', width: '65px', marginRight: '8px', border: 'none', padding: 0 , backgroundColor: '#f6f6f6'}}/>
                                    {'ft - '}
                                    <input
                                    type="number"
                                    value={maxValue}
                                    onChange={handleMaxInputChange}
                                    aria-label="Max Elevation" // Accessibility label
                                    style={{ textAlign: 'center', width: '65px', marginLeft: '8px', border: 'none', padding: 0 , backgroundColor: '#f6f6f6'}}/>
                                    {'ft'}
                                </Typography>
                                </div>
                                </AccordionDetails>
                            </Accordion>

                            {state.mapDataType !== 'FieldSample' &&
                                <Accordion className='accordion-style' defaultExpanded>
                                    <AccordionSummary
                                        className='accordion-title'
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="SeasonalTrendCharts"
                                        id="SeasonalTrendCharts"
                                    >
                                        <div>Seasonal Trend Charts</div>
                                    </AccordionSummary>
                                    <AccordionDetails>

                                        {
                                            state.mapDataType !== 'FieldSample' &&
                                            seasonalTrendList.map((st: any) => (
                                                <div key={st.label} className='inputContainer' style={{ fontSize: 'small', marginTop: '-10px' }}>
                                                    <FormControlLabel
                                                        key={st.label}
                                                        label={<Typography style={{ fontSize: 'small' }}>{st.label}</Typography>}
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                                                        style={{ fontSize: '14px', marginBottom: '1rem' }}
                                                        control={
                                                            <Checkbox checked={state.seasonalTrend?.findIndex((seasonTrend) => seasonTrend.label === st.label) !== -1}
                                                                onChange={() => handleSeasonalTrendSelect(st)} color="success"
                                                            />}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            }
                            {
                                state.mapDataType !== 'FieldSample' &&
                                <Accordion className='accordion-style' defaultExpanded>
                                    <AccordionSummary
                                        className='accordion-title'
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="Network"
                                        id="Network"
                                    >
                                        <div>Network</div>
                                    </AccordionSummary>
                                    <AccordionDetails>

                                        {
                                            state.mapDataType !== 'FieldSample' &&
                                            networkList.map((n: any) => (
                                                <div key={n.label} className='inputContainer' style={{ fontSize: 'small', marginTop: '-10px' }}>
                                                    <FormControlLabel
                                                        key={n.label}
                                                        label={
                                                            <Typography style={{ fontSize: 'small' }}>{n.label} 
                                                                {n.label==='Mesonet' && 
                                                                    <Tooltip title="Due to restrictions in place by the network owner, no hourly weather data is available for restricted networks.">
                                                                        <InfoIcon fontSize='small'/>
                                                                    </Tooltip>
                                                                }
                                                            </Typography>
                                                        }
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 16 } }}
                                                        style={{ fontSize: '14px' }}
                                                        control={
                                                        <Checkbox 
                                                            checked={state.network?.findIndex((network) => network.label === n.label) !== -1} 
                                                            onChange={() => handleNetworkSelect(n)} color="success" 
                                                        />
                                                        }
                                                    />
                                                </div>
                                            ))
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            }
                        </CustomTabPanel>
                    </div>

                </Box>
            </div>
        </div>

    )
}
export default ToolBar;